<div class="sidebar" [ngClass]="isAccountSelection ? 'users' : 'logo'">
    <div *ngIf="!isAccountSelection" class="portal-heading">
        <h1>FortiSIEM Cloud</h1>
    </div>
    <div *ngIf="isAccountSelection" class="user-information">
        <div class="title">
            <span>Welcome Back!</span>
        </div>
        <ul class="user">
            <li *ngIf="userService.accountId() as accountId">
                <label>account</label>
                <div class="title-value">{{accountId}}</div>
            </li>
            <li>
                <label>username</label>
                <div class="title-value">{{userService.userId()}}</div>
            </li>
        </ul>
    </div>
    <div class="account-buttons">
        <button [hidden]="!isEntitlements" type="button" (click)="navigateEntitlements()"
            [ngClass]="isEntitlements && !!serialNumber() ? 'btn-deactive' : ''" class="btn btn-active"
            [title]="isEntitlements && !! serialNumber() ? 'Click to go to all instances' : ''">
            <span class="btn-text deployments">{{isEntitlements && !! serialNumber() ? 'Back to all instances' :
                'Instances'}}</span>
        </button>
        <button [hidden]="!(isEntitlements && !!serialNumber())" class="btn btn-active">
            <span class="btn-text details">{{serialNumber() || ''}}</span>
        </button>
    </div>
    <div class="version">
        <span>v{{version}}</span>
        <span id="fullversion" style="display: none;">{{fullVersion}}</span>
    </div>
</div>
